import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// Copyright 2017-2021 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { u8aConcat } from '@polkadot/util';
import { hmacSha256, hmacSha512 } from "../../hmac/index.mjs";
import { mnemonicToSeedSync } from "../../mnemonic/bip39.mjs";
var ED25519_CRYPTO = 'ed25519 seed'; // gets an xprv from a mnemonic

export function ledgerMaster(mnemonic) {
  var seed = mnemonicToSeedSync(mnemonic);
  var chainCode = hmacSha256(ED25519_CRYPTO, new Uint8Array([1].concat(_toConsumableArray(seed))));
  var priv;

  while (!priv || priv[31] & 32) {
    priv = hmacSha512(ED25519_CRYPTO, priv || seed);
  }

  priv[0] &= 248;
  priv[31] &= 127;
  priv[31] |= 64;
  return u8aConcat(priv, chainCode);
}